var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',[_c('Heading',{attrs:{"title":_vm.lc.title,"divider":false,"tag":"h3"},scopedSlots:_vm._u([{key:"subtitle",fn:function(){return [_c('p',{staticClass:"mt-3",domProps:{"textContent":_vm._s(_vm.lc.description)}})]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }